export class Messages {
    public id: number;
    public conversations_id: number;
    public schedules_id: number;
    public contact_number_id: number;
    public mob_kit_id: string;
    public users_id: number;
    public message_count: number;
    public content: string;
    public date_time_sent: string;
    public date_time_received: string;
    public status: number;
    public is_unread: number;
    public is_deleted: number;
    public is_incoming: number;
    public send_type: number;
}
